import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { pl } from 'date-fns/locale';

interface DateProviderProps {
  children: React.ReactNode;
}

const DateProvider: React.FC<DateProviderProps> = ({ children }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pl}>
      {children}
    </LocalizationProvider>
  );
};

export default DateProvider;
